import { LoaderFunctionArgs, redirect } from "react-router";

export default async function superUserLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/super-user/users");
  return routeParams;
}
